import { useRef } from 'react';
import { useUi } from '../../store/ui.ts';
import { IconGrid, IconList, IconPlus, IconUpload } from '../../lib/icons.tsx';

interface Props {
  onNewFolder: () => void;
  onUploadFiles: (files: File[]) => void;
  onUploadFolder: (files: File[]) => void;
  canEdit: boolean;
}

export function Toolbar({ onNewFolder, onUploadFiles, onUploadFolder, canEdit }: Props) {
  const view = useUi((s) => s.view);
  const setView = useUi((s) => s.setView);
  const fileInput = useRef<HTMLInputElement>(null);
  const folderInput = useRef<HTMLInputElement>(null);

  return (
    <div className="row" style={{ gap: 8 }}>
      <button className="btn" onClick={onNewFolder} disabled={!canEdit}>
        <IconPlus size={16} /> 새 폴더
      </button>
      <button
        className="btn btn--primary"
        onClick={() => fileInput.current?.click()}
        disabled={!canEdit}
      >
        <IconUpload size={16} /> 업로드
      </button>
      <button
        className="btn"
        onClick={() => folderInput.current?.click()}
        disabled={!canEdit}
        title="폴더 통째로 업로드"
      >
        폴더 업로드
      </button>

      <input
        ref={fileInput} type="file" multiple hidden
        onChange={(e) => {
          onUploadFiles(Array.from(e.target.files ?? []));
          e.target.value = '';
        }}
      />
      <input
        ref={folderInput} type="file" multiple hidden
        // webkitdirectory 는 표준 타입 정의에 없어 문자열 속성으로 넘긴다
        {...{ webkitdirectory: '', directory: '' }}
        onChange={(e) => {
          onUploadFolder(Array.from(e.target.files ?? []));
          e.target.value = '';
        }}
      />

      <div className="spacer" />

      <div className="row" style={{ gap: 2 }}>
        <button
          className={view === 'list' ? 'btn btn--icon' : 'btn btn--ghost btn--icon'}
          onClick={() => { setView('list'); }}
          aria-label="목록 보기" aria-pressed={view === 'list'}
        >
          <IconList size={16} />
        </button>
        <button
          className={view === 'grid' ? 'btn btn--icon' : 'btn btn--ghost btn--icon'}
          onClick={() => { setView('grid'); }}
          aria-label="바둑판 보기" aria-pressed={view === 'grid'}
        >
          <IconGrid size={16} />
        </button>
      </div>
    </div>
  );
}
